module.exports = __webpack_public_path__ + "img/pic_france_05.54ae6bd5.jpg";